/*
 * ttl Actions
 *
 * @version 1.0.0
 * @author Magarelli_Fabrizio/DESKTOP-LBDL00N
 * @since 01-Oct-2024
 */

import { createAction } from './index'

export const actionTypes = {
  DO_TTL_CONTROL: '@@ttl/ttl_control'
  // @generator action:type
  // @generator action:type:request
}

// ------------------------------------
// Actions
// ------------------------------------
// @generator action:request

/** @action
 * * Insert a description
 * @name TtlControl
 * @return {object} - The payload object
 */
export const doTtlControl = payload => createAction(actionTypes.DO_TTL_CONTROL, { payload })

// @generator action
